import {ASHFALL_EFFECT} from './ashfall';
import {CRATER_PLUME_EFFECT} from './craterPlume';
import {DUST_DEVIL_EFFECT} from './dustDevil';
import {FAIRY_LIGHTS_EFFECT} from './fairyLights';
import {GEYSER_STEAM_EFFECT} from './geyserSteam';
import {LABYRINTH_GLOW_EFFECT} from './labyrinthGlow';
import {LIVING_LAVA_EFFECT} from './livingLava';
import {RIPPLE_RINGS_EFFECT} from './rippleRings';
import {SAND_STREAMERS_EFFECT} from './sandStreamers';
import {SNOW_DRIFT_EFFECT} from './snowDrift';
import {SPORE_PUFFS_EFFECT} from './sporePuffs';
import {SUN_STARS_EFFECT} from './sunStars';
import {VULTURE_KETTLE_EFFECT} from './vultureKettle';
import {WILL_O_WISPS_EFFECT} from './willOWisps';
import {WIND_GUST_EFFECT} from './windGust';
import {WIND_VEILS_EFFECT} from './windVeils';

/**
 * КАКОЙ ПОДЛОЖКЕ КАКОЙ ЭФФЕКТ (см. configs/fieldBiomeEffects и
 * scenes/FieldBiomeEffects).
 *
 * У каждого эффекта свой файл рядом: вид эффекта и его числа по подложкам
 * (`backgrounds`: идентификатор подложки -> числа). Одна подложка — один
 * эффект; близкие по пейзажу подложки (зеленые, пустыни, зимние) делят один
 * эффект на всех, различаясь только областью картинки и оттенками. Вуали
 * ветра (windVeils) делят соль, два луга и плато — так просил владелец игры.
 *
 * НОВАЯ ПОДЛОЖКА: впиши ее в `backgrounds` подходящего эффекта (или заведи
 * новый эффект: файл чисел здесь + построитель в utils/effects/biome + строка в
 * двух перечнях). Подложка без эффекта — не ошибка: эффекта на ней просто нет;
 * но тест конфига напомнит, что решение не принято.
 */
export const BIOME_EFFECTS = Object.freeze([
  WIND_GUST_EFFECT,
  SAND_STREAMERS_EFFECT,
  SNOW_DRIFT_EFFECT,
  DUST_DEVIL_EFFECT,
  VULTURE_KETTLE_EFFECT,
  WIND_VEILS_EFFECT,
  LABYRINTH_GLOW_EFFECT,
  RIPPLE_RINGS_EFFECT,
  GEYSER_STEAM_EFFECT,
  CRATER_PLUME_EFFECT,
  LIVING_LAVA_EFFECT,
  ASHFALL_EFFECT,
  SUN_STARS_EFFECT,
  WILL_O_WISPS_EFFECT,
  SPORE_PUFFS_EFFECT,
  FAIRY_LIGHTS_EFFECT,
]);

const EFFECT_BY_GROUND_BACKGROUND = Object.freeze(
  BIOME_EFFECTS.reduce((assignments, {kind, backgrounds}) => {
    Object.keys(backgrounds).forEach((groundBackgroundId) => {
      assignments[groundBackgroundId] = Object.freeze({kind, params: backgrounds[groundBackgroundId]});
    });
    return assignments;
  }, {})
);

/**
 * Эффект подложки поля.
 * @param {string|null} [groundBackgroundId] — идентификатор подложки
 * @returns {{kind: string, params: Object}|null} null — эффекта у подложки нет
 */
export const getFieldBiomeEffect = (groundBackgroundId) => (
  // Только свои ключи: подложка приходит и из файла состояния, а имя вроде
  // «constructor» нашлось бы в прототипе объекта
  Object.prototype.hasOwnProperty.call(EFFECT_BY_GROUND_BACKGROUND, groundBackgroundId)
    ? EFFECT_BY_GROUND_BACKGROUND[groundBackgroundId]
    : null
);

/** Подложки, которым эффект назначен (для проверок перечня) */
export const GROUND_BACKGROUNDS_WITH_BIOME_EFFECT = Object.freeze(Object.keys(EFFECT_BY_GROUND_BACKGROUND));
